<!-- MAIN SCREEN//Dashboard -->
<div *ngIf="!registerCredentials" [@fade]>
  <div class="screen screen-5">
    <div class="logo-container">
      <img class="img-logo" src="{{ this.brand_logo }}" alt="img" />
    </div>
    <div class="img-otr hand-cursor notification" routerLink="/order-list">
      <span class="badge" *ngIf="response && response.num_pending_orders > 0">{{
        response.num_pending_orders
      }}</span>
      <p class="desc">My Pending Orders</p>
      <img class="img-inr" src="assets/img/img-4.png" alt="img" />
    </div>
    <div class="img-otr hand-cursor notification" routerLink="/my-payments">
      <span class="badge" *ngIf="response && response.num_payments > 0">{{
        response.num_payments
      }}</span>
      <p class="desc">My Payments</p>
      <img class="img-inr" src="assets/img/img-2.png" alt="img" />
    </div>
    <div
      class="img-otr hand-cursor notification"
      routerLink="/conversation-list"
    >
      <!-- <div class="img-otr hand-cursor notification" (click)="NavigateProviders()"> -->
      <!-- <span class="badge" *ngIf="response && response.num_provider > 0">{{response.num_provider}}</span> -->
      <p class="desc">Contact My Provider</p>
      <img class="img-inr" src="assets/img/img-3.png" alt="img" />
    </div>
    <div class="img-otr hand-cursor notification" routerLink="/appointments">
      <span class="badge" *ngIf="response && response.num_appointments > 0">{{
        response.num_appointments
      }}</span>
      <p class="desc">My Appointments</p>
      <img class="img-inr" src="assets/img/img-4.png" alt="img" />
    </div>
    <div
      class="img-otr last-box hand-cursor notification"
      routerLink="/my-tasks"
    >
      <span class="badge" *ngIf="response && response.num_tasks > 0">{{
        response.num_tasks
      }}</span>
      <p class="desc">My Tasks</p>
      <img class="img-inr" src="assets/img/img-3.png" alt="img" />
    </div>
    <!-- <div class="icon-otr">
        <div class="icon-inr">
            <div class="icon">
                <svg class="setting-icon" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="url(#pattern0)" d="M0 0h24v24H0z"/><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0" transform="matrix(.00575 0 0 .00575 0 -.009)"/></pattern><image id="image0" width="174" height="177" xlink:href="data:image/png;base64,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"/>
                </defs>
            </svg>
            </div>
            <p class="desc">Settings</p>
        </div>
        <a href="" class="icon">
            <svg class="arrow-icon" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.667 4l-.94.94L8.78 8l-3.053 3.06.94.94 4-4-4-4z" fill="#fff"/></svg>
        </a>
    </div> -->
    <!-- <div class="action-otr login-btn" *ngIf="showSwitchButton" >
      <button class="btn-login"  (click)="renderRegisterScreen()" >
        SELF SERVICE
       
      </button>
    </div> -->
    <!-- <div class="action-otr login-btn" style="margin-top: 17px">
      <a routerLink="/home" class="btn-login">
        <i
          class="fa fa fa-power-off"
          style="margin-right: 2%"
          aria-hidden="true"
        ></i
        >LOG OFF</a
      >
    </div> -->
  </div>
</div>

<!-- Register Credentials -->
<!-- <div *ngIf="registerCredentials" [@fade] class="screen screen-3">
  <div class="logo">
    <img class="logo-img" src="assets/img/logo.png" alt="logo" />
  </div>
  <h1 class="heading">Update Login Credentials</h1>
  <form [formGroup]="form" (ngSubmit)="register()">
    <div class="input-otr-password">
      <div class="form-group">
        <label class="input-text-1">New Username</label>
        <div
          *ngIf="f.username.touched || f.username.dirty"
          class="alert alert-danger"
        >
          <p *ngIf="f.username.errors?.minlength" class="error-text">
            <i class="fa fa-times mr-1" aria-hidden="true"></i>Username must be
            atleast 6 characters long.
          </p>
          <p *ngIf="f.username.errors?.maxlength" class="error-text">
            <i class="fa fa-times mr-1" aria-hidden="true"></i>Username can only
            be of 20 characters max.
          </p>
          <p *ngIf="f.username.errors?.required" class="error-text">
            <i class="fa fa-times mr-1" aria-hidden="true"></i>Username is
            required to log in.
          </p>
        </div>
        <input
          type="text"
          class="input"
          formControlName="username"
          [(ngModel)]="username"
        />
      </div>
      <div class="form-group group-position">
        <label class="input-text-1">New Password</label>

        <input
          class="input"
          [type]="!showPass ? 'password' : 'text'"
          formControlName="password"
          [(ngModel)]="password"
        />
        <img
          [src]="
            !showPass ? 'assets/icons/hidden.png' : 'assets/icons/disclosed.png'
          "
          (click)="togglePassword()"
          class="img-inr eye-icon hand-cursor"
          height="25"
          alt="hidden"
        />
      </div>
      <div class="form-group group-position">
        <label class="input-text-1" style="margin-top: 2%"
          >Confirm New Password</label
        >
        <input
          class="input"
          [type]="!showConfirmPass ? 'password' : 'text'"
          formControlName="confirm_password"
          [(ngModel)]="confirm_password"
        />
        <img
          [src]="
            !showConfirmPass
              ? 'assets/icons/hidden.png'
              : 'assets/icons/disclosed.png'
          "
          (click)="toggleConfirmPassword()"
          class="img-inr eye-icon hand-cursor"
          height="25"
          alt="hidden"
        />
      </div>
      <div
        *ngIf="
          (f.password.touched || f.password.dirty) &&
          (f.confirm_password.touched || f.confirm_password.dirty)
        "
        class="alert alert-danger"
      >
        <p *ngIf="form.errors?.mismatch" class="error-text">
          <i class="fa fa-times mr-1" aria-hidden="true"></i>Passwords do not
          match.
        </p>
        <p
          *ngIf="!form.errors?.mismatch"
          class="error-text"
          style="color: green"
        >
          <i class="fa fa-check mr-1" aria-hidden="true"></i>Passwords matched
        </p>
      </div>
      <div *ngIf="f.password.touched || f.password.dirty">
        <p *ngIf="f.password.errors?.minlength" class="error-text">
          <i class="fa fa-times mr-1" aria-hidden="true"></i>Password must be
          atleast 8 characters long.
        </p>
      </div>
    </div>

    <div class="enable-otr">&nbsp;</div>
    <div class="action-otr login-btn" style="padding-top: 22px !important">
      <button
        id="signup-btn"
        [disabled]="!form.valid"
        class="btn-login hand-cursor"
        type="submit"
      >
        Update
      </button>
    </div>
  </form>
  <p class="power-footer">Powered By VYTLsft</p>
</div> -->
